import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	container: {
		minHeight: "100vh",
		display: "flex",
		flexDirection: "column",
		backgroundColor: "#FFFFFF",
		position: "relative",
		overflow: "hidden",
	},
	topSection: {
		width: "100%",
		minHeight: "100vh",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end",
		alignItems: "center",
		padding: "20px",
		position: "relative",
		paddingBottom: "50vh",
	},
	peopleImageContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: "30px",
		flex: 1,
		maxWidth: "100%",
		width: "100%",
	},
	peopleImage: {
		maxWidth: "100%",
		width: "100%",
		height: "auto",
		objectFit: "contain",
	},
	badgesContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "10px",
		marginBottom: "10px",
		flexWrap: "wrap",
		paddingBottom: "10px",
		position: "relative",
		zIndex: 15,
	},
	badge: {
		height: "40px",
		cursor: "pointer",
		transition: "transform 0.2s",
		"&:hover": {
			transform: "scale(1.05)",
		},
	},
	bottomSection: {
		position: "absolute",
		bottom: 0,
		left: 0,
		right: 0,
		width: "100%",
		maxWidth: 480,
		margin: "0 auto",
		backgroundColor: "#FDFCF8",
		borderTopLeftRadius: "30px",
		borderTopRightRadius: "30px",
		padding: "50px 24px 60px 24px",
		minHeight: "45vh",
		display: "flex",
		flexDirection: "column",
		boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
		zIndex: 10,
		animation: "$slideUp 0.6s ease-out",
	},
	"@keyframes slideUp": {
		from: {
			transform: "translateY(100%)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0)",
			opacity: 1,
		},
	},
	content: {
		textAlign: "center",
		maxWidth: "100%",
	},
	title: {
		fontSize: "24px",
		fontWeight: 700,
		color: "#000000",
		marginBottom: "16px",
		lineHeight: "1.3",
		letterSpacing: "-0.5px",
	},
	subtitle: {
		fontSize: "16px",
		color: "#000000",
		marginBottom: "20px",
		lineHeight: "1.5",
		fontWeight: 400,
	},
	instruction: {
		fontSize: "14px",
		color: "rgba(0, 0, 0, 0.6)",
		lineHeight: "1.6",
		fontWeight: 400,
	},
	"@media (min-width: 600px)": {
		title: {
			fontSize: "28px",
		},
		subtitle: {
			fontSize: "18px",
		},
		instruction: {
			fontSize: "16px",
		},
	},
}));

